import { render, staticRenderFns } from "./order_info_dy.mpx?vue&type=template&id=4be7c0f0&scoped=true&component=true&componentId=order_info_dy93a20e60"
import script from "./order_info_dy.mpx?vue&type=script&lang=js&component=true&componentId=order_info_dy93a20e60"
export * from "./order_info_dy.mpx?vue&type=script&lang=js&component=true&componentId=order_info_dy93a20e60"
import style0 from "./order_info_dy.mpx?vue&type=style&index=0&id=4be7c0f0&lang=stylus&scoped=true&mpxStyleOptions=%7B%22mid%22%3A%22m93a20e60%22%7D&component=true&componentId=order_info_dy93a20e60"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be7c0f0",
  null
  
)

export default component.exports